import React from "react";

export const NODE_ENV_DEVELOPMENT = "development";

export const APP_ENV = "_self" in React.createElement("div") ? "dev" : "prod";
export const isInDevelopmentMode = APP_ENV === "dev";

export const DOMAIN = "unforgotten.rip";
